<template>

    <div :key="index" @click="() => {index = 0; visible = true;}" class="g-3">
        <img :src="src" :alt="alt" :class="imgClass" :style="imgStyle" >
    </div>

    <vue-easy-lightbox
        moveDisabled
        scrollDisabled
        escDisabled
        :visible="visible"
        :imgs="[src]"
        :index="index"
        @hide="visible = !visible">
    </vue-easy-lightbox>

</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
    name: 'SingleImagePopup',
    props: {
      src: { required: true },
      alt: { default: '' },
      imgClass: { default: '' },
      imgStyle: { default: '' },
    },
    components: {
        VueEasyLightbox,
    },
    created() {

    },
    data() {
        return {
            index: 0,
            visible: false
        };
    },
    computed: {

    },
    methods: {

    },
};
</script>
